import Component from "./index.vue"

export default {
  name: "interactiveText",
  title: "Interactive Text",
  icon: require("plant-common/src/components/plant-item-viewer/interactive-text/content-icon.svg"),
  Viewer: Component,
  Editor: Component
}
